import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

interface IconTypeToggleProps {
  value: "preset" | "custom";
  onChange: (value: "preset" | "custom") => void;
}

export const IconTypeToggle = ({ value, onChange }: IconTypeToggleProps) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        bgcolor: "action.hover",
        borderRadius: 1.5,
        p: 0.5,
        mb: 2,
      }}
    >
      <Button
        onClick={() => onChange("preset")}
        sx={{
          flex: 1,
          py: 0.75,
          bgcolor: value === "preset" ? "white" : "transparent",
          boxShadow: value === "preset" ? 1 : 0,
          borderRadius: 1,
          fontWeight: 500,
          fontSize: "0.8rem",
          "&:hover": {
            bgcolor: value === "preset" ? "white" : "action.selected",
          },
        }}
      >
        {t("preferences.uiBranding.presetIcon")}
      </Button>
      <Button
        onClick={() => onChange("custom")}
        sx={{
          flex: 1,
          py: 0.75,
          bgcolor: value === "custom" ? "white" : "transparent",
          boxShadow: value === "custom" ? 1 : 0,
          borderRadius: 1,
          fontWeight: 500,
          fontSize: "0.8rem",
          "&:hover": {
            bgcolor: value === "custom" ? "white" : "action.selected",
          },
        }}
      >
        {t("preferences.uiBranding.customSvg")}
      </Button>
    </Box>
  );
};
